<template>
  <div id='app' class='app'>
    <app-refresh />
    <router-view />
    <app-toaster />
    <app-cookie v-if="$featureFlag('enableCookieConsent')"/>
    <portal-target name="app-modal"></portal-target>
    <vue-up />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { subscribe, unsubscribe } from '@/api'
  import appRefresh from '@/pages/authenticated/app-refresh'
  import appToaster from '@/components/app-toaster'
  import appCookie from '@/components/app-cookie'

  export default {
    name: 'app',
    components: {
      appRefresh,
      appToaster,
      appCookie
    },
    metaInfo () {
      return {
        title: this.$t(`brandnames.${this.brandname}`),
        titleTemplate: '%s'
      }
    },

    computed: {
      ...mapState({
        brandname: state => state.brandname,
        errorResponse: state => state.error.response,
        authenticated: state => state.auth.authenticated
      })
    },

    created () {
      this.authChanged()
    },

    mounted () {
      // if (this.$intercom) {
      //   this.$intercom.boot()
      // }
      console.log(`${this.$t(`brandnames.${this.brandname}`)} started with version ${VERSION}`)
    },

    methods: {
      authChanged () {
        if (this.authenticated) {
          subscribe()
        } else {
          unsubscribe()
        }
      }
    },

    watch: {
      authenticated () {
        this.authChanged()
      },

      errorResponse (response) {
        if (!response) return

        const { status } = response

        if (Math.floor(status / 100) === 5) {
          this.$router.push({name: 'error500'})
        }
      }
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/reset';
  @import '~@/styles/common';

  #app {
    overflow-y: hidden
  }

  div.app > .app-toaster {
    padding-top: 8rem;
  }
</style>
